import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cockpit-bg flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-cockpit-panel border border-cockpit-border rounded-sm p-8 text-center">
        <div className="w-20 h-20 bg-amber-900/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-amber-400" />
        </div>
        
        <h1 className="text-2xl font-semibold text-cockpit-text-primary mb-2">
          Payment Cancelled
        </h1>
        <p className="text-cockpit-text-secondary mb-6">
          Your payment was cancelled. No charges were made to your account.
        </p>
        
        <p className="text-sm text-cockpit-text-secondary mb-6">
          You can try again anytime to unlock the full flight workflow system.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full btn-primary py-3 flex items-center justify-center gap-2"
            data-testid="back-to-dashboard-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
